import React, {useEffect, useState} from 'react';
import { Box, Button } from '@mui/material';

import CasaAI from '../../shared/icons/CasaAI';
import DraggableChat from './components/DraggableChat';
import useDraggableChat from './hooks/useDraggableChat';
import useUser from "../../hooks/useUser";

const ChatButton: React.FC = () => {
  const [isChatOpen, setChatOpen] = useState<boolean>(false);
  const { isMinimized, setIsMinimized, view, setView, } = useDraggableChat();

  const { selectedBusiness, setBusiness } = useUser();

  useEffect(() => {
      if(selectedBusiness)
          setChatOpen(false);
  }, [selectedBusiness, setBusiness]);

  const handleToggleChat = (): void => {
      if(isMinimized) setIsMinimized(false)
      setChatOpen(true);
  };

  const handleCloseChat = (): void => {
    setChatOpen(false);
    setIsMinimized(false);
    if(view !== 'chat')  setView('chat');
  };

  return (
    <Box sx={{ height: '40px', position: 'relative', width: 112 }}>
      <Button
        sx={{
          height: 40,
          minHeight: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1.5,
          width: 112,
          boxSizing: 'border-box',
          background: 'linear-gradient(90deg, rgba(200, 189, 255, 0.5) 0%, rgba(247, 213, 255, 0.5) 100%)',
          color: '#270D9F',
          fontWeight: 700,
          borderRadius: '12px',
          textTransform: 'none',
          overflow: 'hidden',
          position: 'relative',
          '&:hover': {
            background: 'linear-gradient(90deg, rgba(170, 159, 225, 0.7) 0%, rgba(227, 193, 235, 0.7) 100%)',
          },

          '&::after': {
              content: '"BETA"',
              position: 'absolute',
              top: '6px',
              left: '-18px',
              backgroundColor: '#F2755F',
              color: '#fff',
              fontSize: '9px',
              fontWeight: 950,
              width: '65px',
              height: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'rotate(-45deg)',
              boxShadow: '0px 1px 3px rgba(0,0,0,0.2)',
              pointerEvents: 'none',
              letterSpacing: '0.5px',
              zIndex: 2,
          }
        }}
        onClick={handleToggleChat}
      >
        <span
          style={{
            height: 28,
            width: 28,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <CasaAI sx={{ fontSize: 30 }} />
        </span>
        <span style={{ marginLeft: 4, whiteSpace: 'nowrap'}}>Gargi</span>
      </Button>
      <DraggableChat open={isChatOpen} onClose={handleCloseChat} />
    </Box>
  );
};

export default ChatButton;